import {
  SchemaValidationLongDisplayTextByStatus,
  SchemaValidationState,
  ValidationExtras,
} from 'schemas/SchemaValidationConstants';

import {isFailed} from './SchemaValidationChecks';

function longErrorText(error: string): string {
  return `${SchemaValidationLongDisplayTextByStatus.FAILED}: ${error}`;
}

export default function getValidationErrorText(
  schemaValidationState: SchemaValidationState | null | undefined,
  validationExtras: ValidationExtras | null | undefined,
  short: boolean = false
): string | null {
  if (
    !schemaValidationState ||
    !isFailed(schemaValidationState) ||
    !validationExtras ||
    !validationExtras.errorRecords ||
    !validationExtras.errorRecords.length
  ) {
    return null;
  }
  // Prioritize rendering validation errors not tied to a field -- these tend to be of higher priority,
  // e.g., duplicate errors
  const firstMessage = validationExtras.errorRecords[0].message;
  const priorityMessage = fieldlessValidationErrorTexts(validationExtras, short)[0];
  if (priorityMessage) {
    return priorityMessage;
  }
  return short ? firstMessage : longErrorText(firstMessage);
}

export function fieldlessValidationErrorTexts(
  validationExtras?: ValidationExtras | null,
  short: boolean = false
): Array<string> {
  const fieldlessErrors =
    validationExtras &&
    validationExtras.errorRecords &&
    validationExtras.errorRecords.filter(({field}) => field == null);
  return fieldlessErrors
    ? fieldlessErrors.map((error) => (short ? error.message : longErrorText(error.message)))
    : [];
}
